const ProductRequestTypesEnum = Object.freeze({
  GAMIFICATION: 'Gamification',
  CUSTOMER_INTELLIGENCE: 'Customer Intelligence',
  INFINITY_AI: 'InfinityAI',
  JOURNEY_BUILDER_2: 'Journey Builder 2.0'
})

export { ProductRequestTypesEnum }



// WEBPACK FOOTER //
// ./src/common/enum/ProductRequestTypesEnum.js